<template>
  <div>
    <mu-dialog
      title="打印提货单"
      width="1000"
      :open="open"
      @close="close"
      class="invoice-dialog"
      scrollable
    >
      <mu-data-table
        stripe
        :columns="productColumns"
        :data="invoice.products"
        class="table"
        selectable
        select-all
        checkbox
        :selects.sync="selects"
      >
        <template slot-scope="scope">
          <td class="is-center">{{ scope.$index + 1 }}</td>
          <td class="is-center">{{ scope.row.name }}</td>
          <td class="is-center">{{ scope.row.specification }}</td>
          <td class="is-center">{{ scope.row.price }}</td>
          <td class="is-center">
            <mu-text-field
              v-model="scope.row.count"
              placeholder="数量"
              @change="countChange(scope.row)"
            ></mu-text-field>
          </td>
          <td class="is-center">{{ scope.row.sum }}</td>
        </template>
      </mu-data-table>
      <mu-button slot="actions" color="primary" @click="submit">打印</mu-button>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import numeral from 'numeral'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      invoice: {
        products: []
      },
      productColumns: [
        {
          title: '序号',
          name: 'index',
          align: 'center'
        },
        {
          title: '名称',
          name: 'name',
          align: 'center'
        },
        {
          title: '规格',
          name: 'specification',
          align: 'center'
        },
        {
          title: '单价',
          name: 'price',
          align: 'center'
        },
        {
          title: '数量',
          name: 'count',
          align: 'center'
        },
        {
          title: '总价',
          name: 'sum',
          align: 'center'
        }
      ],
      selects: []
    }
  },
  methods: {
    submit() {
      const invoice = JSON.parse(JSON.stringify(this.invoice))
      invoice.products = invoice.products.filter(
        (x, index) => this.selects.indexOf(index) > -1
      )
      const sum = numeral(0)
      invoice.products.forEach((item) => {
        sum.add(item.sum)
      })
      invoice.sum = sum.value()
      backend(api.order.generateInvoice, invoice).then((result) => {
        if (result.statusCode === 200) {
          window.open(result.data.url, '_blank')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    countChange(product) {
      product.sum = numeral(product.price).multiply(product.count).value()
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.invoice = JSON.parse(JSON.stringify(this.form))
        this.selects = this.invoice.products.map((item, index) => index)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.invoice-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/order/invoice.vue